define( [
	"../../core",
	"../../selector"
], function( jQuery ) {
	"use strict";

	return jQuery.expr.match.needsContext;
} );



//////////////////
// WEBPACK FOOTER
// ./~/jquery/src/traversing/var/rneedsContext.js
// module id = 1829
// module chunks = 36